var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-color"},[_c('home-topbar'),_c('home-first-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }